<template>
	<el-form :model="queryFormData" :inline="true" class="workbenchFormWrap">
		<el-row>
			<el-col :span="6">
				<el-form-item label="审批内容" label-width="90px">
					<el-input
						v-model="queryFormData.itemName"
						placeholder="请输入审批内容"
					></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="审批流类别" label-width="90px">
					<el-select
						v-model="queryFormData.type"
						placeholder="请选择审批流类别"
						clearable
					>
						<el-option
							v-for="item in approvalProcessTypeList"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="项目部" label-width="90px">
					<el-select
						v-model="queryFormData.applyDeptId"
						placeholder="请选择项目部"
						@change="handleDeptChange"
						clearable
					>
						<el-option
							v-for="item in projectDeptList"
							:key="item.applyDeptId"
							:label="item.applyDeptName"
							:value="item.applyDeptId"
						></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<div v-if="showAdvanceFilter">
				<el-col :span="6">
					<el-form-item label="项目名称" label-width="90px">
						<el-select
							v-model="queryFormData.projectId"
							placeholder="请选择项目名称"
							clearable
						>
							<el-option
								v-for="item in projectList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6" v-if="jumpType!='submitUnapproval'">
					<el-form-item label="提交人" label-width="90px">
						<el-input
							v-model="queryFormData.submitUserName"
							placeholder="请输入提交人"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6" v-if="jumpType!='submitUnapproval'">
					<el-form-item label="提交人部门" label-width="90px">
						<el-cascader
							v-model="submitUserDeptId"
							:options="deptList"
							:props="queryDeptChildrenProps"
							@change="changeSubmitUserDeptId"
							placeholder="请选择提交人部门"
							change-on-select
							clearable
							style="width:100%"
						></el-cascader>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="提交时间" label-width="90px">
						<el-date-picker
							v-model="submitTime"
							type="daterange"
							value-format="yyyy-MM-dd"
							@change="submitTimeChange"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
						>
						</el-date-picker>
					</el-form-item>
				</el-col>
			</div>
			<el-col :span="6">
				<div class="btnWrap">
					<el-button type="primary" @click="searchData"
						>查询
					</el-button>
					<el-button type="info" @click="resetSearch">重置</el-button>
					<el-button type="text" @click="moreScreen"
						>{{ showAdvanceFilter ? "收起" : "高级筛选" }}
					</el-button>
				</div>
			</el-col>
		</el-row>
	</el-form>
</template>

<script>
import {
	getProjectDeptListApi,
	getProjectListApi,
	getDeptListApi,
	getSubDeptListApi,
} from "../../../services/workbenchServices";

export default {
	name: "queryHeader",
	props: {
        jumpType:{
            type:String

        },
    },
	data() {
		return {
			queryFormData: {
				itemName: "", //审批内容
				type: "", //审批流类型
				applyDeptId: "", //项目部
				projectId: "", //项目
				submitUserName: "", //提交人
				submitUserDeptId: "", //提交人部门
				createTimeStart: "", //提交开始时间
				createTimeEnd: "", //提交结束时间
			},
			submitUserDeptId: [],
			submitTime: [],
			approvalProcessTypeList: [
				{ value: "SUPPLIER", label: "合作单位" }, //供应商
				{ value: "PROJECT_FRONT", label: "事前成本" }, //事前成本
				{ value: "PROJECT_MIDDLE", label: "事中成本" }, //事中成本
				{ value: "GENERAL_CONTRACT", label: "总包合同" }, //总包合同
				{ value: "PROJECT", label: "项目" }, //项目
				{ value: "SUB_CONTRACT", label: "分项合同" }, //分项合同
				{ value: "DECLARATION", label: "会议提报" }, //会议提报
				{ value: "INPUT_BILL_APPROVE", label: "进项发票" }, //进项发票报销审批
				{ value: "OUTPUT_BILL_APPROVE", label: "销项发票" }, //销项发票报销审批
				{ value: "EARNING_COST", label: "收入列表" }, //收入成本
				{ value: "OFFICIAL_DOCUMENT_INTERNAL", label: "公文-内部文件(其他)" }, //公文-内部
				{ value: "OFFICIAL_DOCUMENT_EXTERNAL", label: "外部公文" }, //公文-外部
				{ value: "OFFICIAL_DOCUMENT_INTERNAL_GENERAL_OFFICE", label: "公文-内部文件(综合办)" }, //公文-外部
				{ value: "SPORADIC_PROJECT", label: "零星工程" }, //公文-外部
				{ value: "BID_PLAN", label: "采购计划" }, //采购计划
				{ value: "BID_PRICE_CONTROLE", label: "控制价审核" }, //控制价审核
				{ value: "BID_FILE", label: "采购文件审核" }, //采购文件审核
				{ value: "BID_JOIN_SIGNATURE", label: "联签单" }, //采购联签单
			
			], //审批流类型
			projectDeptList: [], //项目部
			projectList: [], //项目
			deptList: [], //部门
			queryDeptChildrenProps: {
				label: "name",
				value: "id",
				checkStrictly: true,
				lazy: true,
				lazyLoad(node, resolve) {
					const param = {};
					if (undefined != node.value) {
						param.deptId = node.value;
						getSubDeptListApi(param).then((res) => {
							if (res.code == 10000000) {
								const nodes = res.data;
								nodes.forEach((item) => {
									item.leaf = item.isLeaf == 1;
								});
								resolve(nodes);
							} else {
								this.$message.error(res.msg);
							}
						});
					}
				},
			}, //部门列表懒加载
			showAdvanceFilter: false,
		};
	},
	created() {
		this.getProjectDeptData();
		this.getDeptData();
	},
	methods: {
		//获取项目部列表
		getProjectDeptData() {
			getProjectDeptListApi()
				.then((res) => {
					if (res.code == 10000000) {
						this.projectDeptList = res.data || [];
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});
		},
		//项目部变化
		handleDeptChange(value) {
			this.queryFormData.projectId = "";
			this.projectList = [];
			if (value) {
				getProjectListApi({ deptId: value })
					.then((res) => {
						if (res.code == 10000000) {
							this.projectList = res.data || [];
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch(() => {
						this.$message.error("网络请求失败");
					});
			}
		},
		//获取部门
		getDeptData() {
			getDeptListApi({
				pid: 0,
				orgId: 1 || sessionStorage.getItem("deptId"),
			})
				.then((res) => {
					if (res.code == 10000000) {
						this.deptList = res.data || [];
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});
		},
		//部门更改
		changeSubmitUserDeptId(value) {
			if (value?.length) {
				this.queryFormData.submitUserDeptId = value[value.length - 1];
			} else {
				this.queryFormData.submitUserDeptId = "";
			}
		},
		// 提交时间修改
		submitTimeChange(value) {
			if (value?.length > 1) {
				this.queryFormData.createTimeStart = value[0];
				this.queryFormData.createTimeEnd = value[1];
			} else {
				this.queryFormData.createTimeStart = "";
				this.queryFormData.createTimeEnd = "";
			}
		},
		//高级筛选
		moreScreen() {
			this.showAdvanceFilter = !this.showAdvanceFilter;
		},
		//查询
		searchData() {
			this.$emit("queryData", this.queryFormData);
		},
		//重置
		resetSearch() {
			this.queryFormData = {
				itemName: "", //审批内容
				type: "", //审批流类型
				applyDeptId: "", //项目部
				projectId: "", //项目
				submitUserName: "", //提交人
				submitUserDeptId: "", //提交人部门
				createTimeStart: "", //提交开始时间
				createTimeEnd: "", //提交结束时间
			};
			this.submitUserDeptId = [];
			this.submitTime = [];
			this.projectList = [];
			this.$emit("queryData", this.queryFormData);
		},
	},
};
</script>

<style scoped lang="scss">
.workbenchFormWrap {
	border-bottom: 1px solid #e6e6e6;

	/deep/ .el-form-item {
		width: 100%;
		margin-right: 0;

		.el-form-item__content {
			width: calc(100% - 90px);

			.el-select {
				width: 100%;
			}

			.el-date-editor {
				width: 100%;
			}
		}
	}

	.btnWrap {
		text-align: right;
	}
}
</style>
